<template>
  <div>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          :disabled="
            (params && params.data && params.data.status == 'Rejected') ||
            params.data.status == 'Verified'
          "
          class="ml-1 mr-2"
          color="success"
          v-on="on"
          v-bind="attrs"
          @click="acceptCompany"
        >
          mdi-check-bold
        </v-icon>
      </template>
      <span>Accept</span>
    </v-tooltip>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          :disabled="params && params.data && params.data.status == 'Rejected'"
          class="ml-1 mr-2"
          color="error"
          v-on="on"
          v-bind="attrs"
          @click="rejectCompany"
        >
          mdi-backspace
        </v-icon>
      </template>
      <span>Reject</span>
    </v-tooltip>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewAttachment"
        >
          mdi-file-document-edit
        </v-icon>
      </template>
      <span>Company Request Document</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    acceptCompany() {
      this.params.context.parentComponent.acceptCompanyData(this.params.data);
    },
    rejectCompany() {
      this.params.context.parentComponent.rejectCompanyData(this.params.data);
    },
    viewAttachment() {
      this.params.context.parentComponent.companyRequestAttachment(
        this.params.data
      );
    },
  },
};
</script>

<style></style>
